module.exports = __webpack_public_path__ + "static/media/3.64371daa.webp";